/**
 * 活动中心
 * @returns
 */
import { Box, Button, Flex, SimpleGrid, Image, Input } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import ActivityItem from "@/components/activity";
import { Activity } from "@/types/activity";
import actBanner from "@/assets/images/activity_banner.png";
import actImg from "@/assets/images/activity_img1.png";
import { useState } from "react";
import { useGetActivitysQuery } from "@/services/api/endpoints/activity";
import emptyImg from "@/assets/images/empty.png";

const ActivityCenter = () => {
  const navigate = useNavigate();
  const { data: activitiesList } = useGetActivitysQuery();
  const [searchValue, setSearchValue] = useState("");

  const handleChangeSearchValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };
  const handleSearch = () => {};

  // const activitiesList = [
  //   {
  //     template1: `${actImg}`,
  //     name: "AI光影建筑故事绘",
  //     start_time: 1714510561,
  //     end_time:1716961605,
  //     status: "未开始",
  //   },
  //   {
  //     template1: `${actImg}`,
  //     name: "AI光影建筑故事绘",
  //     start_time: 1714510561,
  //     end_time:1716961605,
  //     status: "进行中",
  //   },
  //   {
  //     template1: `${actImg}`,
  //     name: "AI光影建筑故事绘",
  //     start_time: 1714510561,
  //     end_time:1716961605,
  //     status: "已结束",
  //   }
  // ] as Activity[];

  return (
    <Box h="calc(100vh - 61px)" overflow={"hidden"}>
      <Box h="100%" width="80%" m="0 auto">
        <Flex h="100%" flexDirection={"column"}>
          <Flex
            justifyContent={"space-between"}
            alignItems="center"
            mt="40px"
            mb="20px"
          >
            <Box color="#27314D" fontWeight="bold" fontSize="24px">
              活动中心
            </Box>
            {/* 搜索 */}
            <Box>
              <Input
                h="40px"
                w="400px"
                boxSizing="border-box"
                border="1px solid #CBD1DF"
                borderRadius={0}
                bg="none"
                color={"#8E94A9"}
                fontSize="12px"
                placeholder="请输入"
                size="md"
                value={searchValue}
                onChange={handleChangeSearchValue}
              />
              <Button
                w="102px"
                h="40px"
                ml="14px"
                border={"1px solid #CBD1DF"}
                bg="none"
                color={"#8E94A9"}
                fontSize="14px"
                fontWeight={"normal"}
                borderRadius={0}
                _hover={{}}
                onClick={handleSearch}
              >
                我的活动
              </Button>
            </Box>
          </Flex>
          <Flex h="0" flex={1} flexDirection="column" overflow={"auto"} pr="10px">
          <Box mb="40px">
            <Image w="100%" src={actBanner} />
          </Box>
          
            {!activitiesList?.length && (
              <Flex
                h="0"
                flex={1}
                flexDir={"column"}
                justifyContent="center"
                alignItems={"center"}
              >
                <Image h="120px" src={emptyImg} />
                <Box fontSize={"14px"} color={"#8E94A9"}>
                  现在活动中心还没有活动，请耐心等待～
                </Box>
              </Flex>
            )}
            {activitiesList && activitiesList.length>0 && (
              <Box >
                <SimpleGrid
                  spacingX="28px"
                  spacingY="40px"
                  mb="40px"
                  columns={2}
                >
                  {activitiesList.map((item) => {
                    return (
                      <Box key={item.id}>
                        <ActivityItem activity={item} />
                      </Box>
                    );
                  })}
                </SimpleGrid>
              </Box>
            )}
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};
export default ActivityCenter;
